@if (template && instance) {
  <div class="file-sequence-container">
    <span class="span-header">{{ template.name }}</span>
    <div class="file-sequence-container">
      <div
        [pTooltip]="tooltipName(instance)"
        tooltipPosition="top"
        class="file-sequence-div"
      >
        <p-tag icon="pi pi-file-plus" value="{{ inlineName(instance) }}" />
        <p-tag icon="pi pi-hashtag" value="{{ instance.value }}" />
      </div>
    </div>
  </div>
}
